export class CvKitchenEquipmentLayout {
	public fields = [
		{ fieldName: 'cv_equipmentType', label: 'Type' },
		{ fieldName: 'cv_equipmentDescription', label: 'Description' }
	];
}
